import createBottomComponent from "../../../../helpers/common/CoreInputText/components/Bottom/fabric";
import { INPUT_TEXT_DISPLAY_NAME } from "../../utils/core";

export const Component = createBottomComponent(INPUT_TEXT_DISPLAY_NAME);
export default Component;
